import instagram from '../Icons/instagram.ejs';
import twitter from '../Icons/twitter.ejs';
import facebook from '../Icons/facebook.ejs';

import styles from './styles.less';
import socialButtonTemplate from './socialButton.ejs';

interface Data {
    type: 'facebook' | 'twitter' | 'instagram';
}

export default function(data: Data) {
    return socialButtonTemplate({
        ...data,
        instagram,
        twitter,
        facebook,
        styles,
    });
}
